import AbstractModule from './AbstractModule'
import {$document, $html, APP_NAME} from '../utils/environment'

const MODULE_NAME = 'PaymentPopup';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    TOGGLE: `toggle.${EVENT_NAMESPACE}`,
    CLICK: `click.${EVENT_NAMESPACE}`
}

export default class extends AbstractModule {
    /**
     * Constructor.
     *
     * @return {void}
     */
    constructor(options) {
        super(options)
    }

    init() {
        $document.on(EVENT.TOGGLE, ({flag = true}) => this.togglePopup( flag ));
        this.$el.on(EVENT.CLICK, '.js-payment-close', () => this.togglePopup(false));
    }

    togglePopup(flag) {
        $html.toggleClass('has-payment-open', flag);
    }

    /**
     * Destructor.
     *
     * @return {void}
     */
    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $document.off(`.${EVENT_NAMESPACE}`);
    }
}
